import React, { memo } from 'react';
import { TableFlex } from '@cognitiv/cyprus-ui';
import {
  CompletedCell,
  CreatedByCell,
  CreatedCell,
  FailedCell,
  IdCell,
  JobsCell,
  NameCell,
  QueuedCell,
  RunningCell,
  StartingCell,
  StateCell,
  StoppedCell,
} from 'components/batch-history/Cells';
import { headers } from 'components/batch-history/constants';
import { BatchHistoryTableProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';

const BatchHistoryTableBase = ({ rows }: BatchHistoryTableProps) => {
  const { is_dark_theme } = useSwitchTheme();
  return (
    <TableFlex
      key={is_dark_theme}
      settings={{ row_height: 32, header_row_height: 32 }}
      headers={headers}
      rows={rows.map((row) => ({ ...row }))}
    >
      <IdCell />
      <NameCell />
      <StateCell />
      <JobsCell />
      <QueuedCell />
      <StartingCell />
      <StoppedCell />
      <RunningCell />
      <CompletedCell />
      <FailedCell />
      <CreatedByCell />
      <CreatedCell />
    </TableFlex>
  );
};

export const BatchHistoryTable = memo(BatchHistoryTableBase);
